import { render, staticRenderFns } from "./emailLineElementEditor.vue?vue&type=template&id=15b75714&scoped=true&"
import script from "./emailLineElementEditor.vue?vue&type=script&lang=js&"
export * from "./emailLineElementEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b75714",
  null
  
)

export default component.exports